import { render, staticRenderFns } from "./PreviewEmailTemplate.vue?vue&type=template&id=183a1165&scoped=true"
import script from "./PreviewEmailTemplate.vue?vue&type=script&lang=js"
export * from "./PreviewEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./PreviewEmailTemplate.vue?vue&type=style&index=0&id=183a1165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a1165",
  null
  
)

export default component.exports